module.exports = __webpack_public_path__ + "static/media/preb-logo.16888c60.png";